<template>
  <div class="org-diagrams">
    <div class="org-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        class="org-tab-btn"
        :class="{ 'is-active': activeTab === tab.key }"
        type="button"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Diagramme : Bureau -->
    <section class="org-block" v-show="activeTab === 'bureau'">
      <div class="org-header">
        <div class="org-header-season">Saison {{ saison }}</div>
      </div>

      <div class="org-tree">
        <div class="org-row org-row-double">
          <div
            class="org-box org-box-black"
            v-for="p in bureau.presidents"
            :key="p.title"
          >
            <div class="org-box-header">{{ p.title }}</div>
            <div class="org-box-body">
              <p>{{ p.name }}</p>
            </div>
          </div>
        </div>
        <div class="org-connector"></div>

        <div class="org-row org-row-four org-tree-branch">
          <div
            class="org-box org-box-office"
            v-for="p in bureau.officers"
            :key="p.title"
          >
            <div class="org-box-header">{{ p.title }}</div>
            <div class="org-box-body">
              <p>{{ p.name }}</p>
            </div>
          </div>
        </div>

        <div class="org-banner">Responsables de commissions</div>
        <div class="org-connector"></div>

        <div class="org-row org-row-five org-tree-branch">
          <div
            class="org-branch-col"
            v-for="r in bureau.responsables"
            :key="r.title"
          >
            <div class="org-box org-box-office">
              <div class="org-box-header">{{ r.title }}</div>
              <div class="org-box-body">
                <p>{{ r.name }}</p>
              </div>
            </div>
            <div class="org-box org-box-sub-small" v-if="r.child">
              <div class="org-box-header">{{ r.child.title }}</div>
              <div class="org-box-body">
                <p>{{ r.child.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="org-baseline">Ensemble, plus forts !</p>
    </section>

    <!-- Diagramme : Équipe technique -->
    <section class="org-block" v-show="activeTab === 'equipe'">
      <h2 class="org-block-title">L'équipe technique saison {{ saison }}</h2>

      <div class="org-tree">
        <div class="org-row org-row-single">
          <div class="org-box org-box-main">COMITÉ DIRECTEUR</div>
        </div>
        <div class="org-connector org-connector-single"></div>
        <div class="org-row org-row-single">
          <div class="org-box org-box-sub">
            <div class="org-box-header">COORDINATEUR SPORTIF</div>
            <div class="org-box-body">
              <p>Nicolas HASPOT</p>
              <p class="org-tag">BMF</p>
            </div>
          </div>
        </div>
        <div class="org-connector"></div>

        <div class="org-branches org-branches-3 org-tree-branch">
          <div
            class="org-branch"
            v-for="branch in equipeTechnique"
            :key="branch.title"
          >
            <div class="org-box org-box-branch">{{ branch.title }}</div>
            <div class="org-branch-content">
              <div
                class="org-group"
                v-for="group in branch.groups"
                :key="group.title"
              >
                <div class="org-box org-box-group">
                  <div class="org-box-header">
                    {{ group.title }}
                    <span v-if="group.tag" class="org-tag">{{
                      group.tag
                    }}</span>
                  </div>
                  <div
                    class="org-box-body"
                    v-if="group.people && group.people.length"
                  >
                    <p v-for="(p, i) in group.people" :key="i">{{ p }}</p>
                  </div>
                  <div class="org-box-body" v-if="group.phone">
                    <p>{{ group.phone }}</p>
                  </div>
                </div>

                <div class="org-subgroups" v-if="group.sub && group.sub.length">
                  <div
                    class="org-box org-box-sub-small"
                    v-for="(s, si) in group.sub"
                    :key="si"
                  >
                    <div class="org-box-header">
                      <span
                        v-if="s.flag"
                        class="org-flag"
                        :class="'org-flag-' + s.flag"
                        :title="s.flagLabel"
                      ></span>
                      <template v-else>{{ s.title }}</template>
                      <span v-if="s.tag" class="org-tag">{{ s.tag }}</span>
                    </div>
                    <div
                      class="org-box-body"
                      v-if="s.people && s.people.length"
                    >
                      <p v-for="(p, i) in s.people" :key="i">{{ p }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Diagramme : Commissions -->
    <section class="org-block" v-show="activeTab === 'commissions'">
      <div class="org-header">
        <div class="org-header-season">Saison {{ saison }}</div>
      </div>
      <h3 class="org-header-commissions">Commissions</h3>

      <div class="org-grid">
        <div
          class="org-card"
          v-for="commission in commissions"
          :key="commission.title"
        >
          <div class="org-card-title">{{ commission.title }}</div>
          <ul
            class="org-card-list"
            v-if="commission.members && commission.members.length"
          >
            <li v-for="(m, i) in commission.members" :key="i">{{ m }}</li>
          </ul>
          <p class="org-card-empty" v-else>
            {{ commission.status || "À pourvoir" }}
          </p>
        </div>
      </div>

      <p class="org-baseline">Ensemble, plus forts !</p>
    </section>
  </div>
</template>

<script>
export default {
  name: "OrganigrammeDiagram",
  data() {
    return {
      activeTab: "bureau",
      tabs: [
        { key: "bureau", label: "Bureau" },
        { key: "equipe", label: "Équipe technique" },
        { key: "commissions", label: "Commissions" },
      ],
      saison: "2026-2027",
      equipeTechnique: [
        {
          title: "LOISIRS / SENIORS",
          groups: [
            {
              title: "SENIORS",
              people: ["Nicolas RAIMBAUD", "06 32 99 98 06"],
              sub: [
                { title: "D2", people: ["Nicolas RAIMBAUD"] },
                { title: "D3", people: ["Romuald PUAUD", "Hervé FLOTTES"] },
                { title: "D4", people: ["Pascal JOUET"] },
              ],
            },
            {
              title: "LOISIRS",
              people: ["Vincent ROBERT", "06 50 14 32 13"],
            },
          ],
        },
        {
          title: "FORMATION",
          groups: [
            {
              title: "U17/U18",
              tag: "BMF",
              people: ["Nicolas HASPOT", "06 88 31 60 08"],
              sub: [
                { title: "D2", people: ["Nicolas HASPOT", "Nathan HAMON"] },
                {
                  title: "D4 (entente)",
                  people: ["Pascal JOUET", "+ Dirigeant ST ANDRE"],
                },
              ],
            },
            {
              title: "U14/U15",
              people: ["Yoan PARVEDY", "07 60 60 21 71"],
              sub: [
                { title: "D3", people: ["Charles LAHAYE", "Mickael DIORFLAR"] },
                { title: "D5", people: ["Mickael CHOPIN"] },
              ],
            },
            {
              title: "U14/U15 F",
              people: ["Boualem LOUIBA", "06 50 23 50 43", "U15 foot à 8"],
              sub: [
                {
                  title: "",
                  people: [
                    "Boualem LOIBA",
                    "Julien OILLAUX",
                    "Arthur DAVID (U17)",
                  ],
                },
              ],
            },
          ],
        },
        {
          title: "ÉCOLE DE FOOT",
          groups: [
            {
              title: "U12/U13",
              tag: "Alternant BP2EPS",
              people: ["Shanis BAHOLET", "07 61 30 53 53"],
              sub: [
                {
                  title: "D4",
                  people: ["Shanis BAHOLET", "Renaud ANFREVILLE"],
                },
                { title: "D5", people: ["Fabien PALETTE", "???"] },
              ],
            },
            {
              title: "U10/U11",
              tag: "BMF",
              people: ["Nicolas HASPOT", "06 88 31 60 08"],
              sub: [
                {
                  flag: "fr",
                  flagLabel: "France",
                  people: ["Nicolas HASPOT", "Manu MICHEL"],
                },
                {
                  flag: "br",
                  flagLabel: "Brésil",
                  people: ["Ewen BELLIOT (U18)", "Ylies BOURDON (U18)"],
                },
                {
                  flag: "es",
                  flagLabel: "Espagne",
                  people: ["Loic DESRUES", "Louison DAUCE (U18)"],
                },
              ],
            },
            {
              title: "U8/U9",
              tag: "Alternant BP3EPS",
              people: ["Shanis BAHOLET", "07 61 30 53 53"],
              sub: [
                {
                  title: "",
                  people: ["Melvin GUIHENEUF", "Loris ANFREVILLE", "+ ???"],
                },
              ],
            },
            {
              title: "U6/U7",
              tag: "Module U6 FFF",
              people: ["Claudio AQUINO", "06 69 02 05 93"],
            },
          ],
        },
      ],
      commissions: [
        {
          title: "SPONSORING",
          members: [
            "Nicolas Rivalland",
            "Ludovic Chatal",
            "Anthony Bercegeay",
            "Nicolas Julienne",
            "Thierry Regardin",
          ],
        },
        {
          title: "EDUCATIVE",
          members: [
            "Carine Gueritte",
            "Nelly Lahaye",
            "Frédéric Bourdon",
            "Marion Vilcoq",
            "Maud Pasquier",
            "Nicolas Guihéneuf",
            "Nicolas Haspot",
          ],
        },
        { title: "SPORTIVE", status: "En cours" },
        {
          title: "ARBITRAGE",
          members: ["Arnaud Guégan", "Erwan Bourland"],
        },
        { title: "FESTIVITÉS", status: "À pourvoir" },
        {
          title: "BAR",
          members: ["Nelly Lahaye", "Guillaume Dauce", "Vanessa Anfreville"],
        },
        { title: "TRAVAUX", status: "À pourvoir" },
        {
          title: "COMMUNICATION",
          members: [
            "Amy Chatal",
            "Charlotte Mercier",
            "Elise André",
            "Maéline Gesnouin",
          ],
        },
        {
          title: "BOUTIQUE / MATÉRIEL",
          members: ["Corentin Mahé"],
        },
      ],
      bureau: {
        presidents: [
          { title: "CO-PRÉSIDENT", name: "SÉBASTIEN CHATAL" },
          { title: "CO-PRÉSIDENT", name: "DAVID BRISSON" },
        ],
        officers: [
          { title: "SECRÉTAIRE", name: "ÉLISE GUIHO" },
          { title: "SECRÉTAIRE ADJOINT(E)", name: "À pourvoir" },
          { title: "TRÉSORIER", name: "NICOLAS CLAVIER" },
          { title: "TRÉSORIER ADJOINT(E)", name: "VANESSA CHATAL" },
        ],
        responsables: [
          {
            title: "SPONSORING",
            name: "NICOLAS RIVALLAND",
            child: { title: "COMMUNICATION", name: "À pourvoir" },
          },
          {
            title: "ARBITRAGE",
            name: "ARNAUD GUÉGAN",
            child: { title: "TRAVAUX", name: "À pourvoir" },
          },
          {
            title: "BOUTIQUE / MATÉRIEL",
            name: "CORENTIN MAHÉ",
            child: { title: "SPORTIVE", name: "NICOLAS HASPOT" },
          },
          {
            title: "FESTIVITÉS",
            name: "NICOLAS GUIHÉNEUF",
            child: { title: "EDUCATIVE", name: "NICOLAS GUIHÉNEUF" },
          },
          { title: "BAR", name: "NELLY LAHAYE" },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
$org-orange: #e75913;
$org-black: #1a1a1a;

.org-diagrams {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f5f5f5;

  .org-tabs {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 24px 5% 0;
    background: #f5f5f5;
  }

  .org-tab-btn {
    border: 2px solid $org-orange;
    background: #ffffff;
    color: $org-orange;
    font-weight: 700;
    letter-spacing: 0.5px;
    padding: 10px 24px;
    border-radius: 30px;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
      background: rgba($org-orange, 0.1);
    }

    &.is-active {
      background: $org-orange;
      color: #ffffff;
    }
  }

  .org-block {
    padding: 40px 5%;
    background: #f5f5f5;
  }

  .org-block-title {
    text-align: center;
    font-weight: 700;
    font-size: 1.6rem;
    text-decoration: underline;
    margin-bottom: 30px;
    color: $org-black;
  }

  .org-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .org-header-season {
      font-weight: 700;
      color: $org-orange;
    }
  }

  .org-header-commissions {
    text-align: center;
    font-weight: 700;
    font-size: 1.3rem;
    margin-bottom: 30px;
    color: $org-black;
  }

  .org-baseline {
    text-align: center;
    font-weight: 700;
    margin-top: 30px;
    color: $org-black;

    &::before,
    &::after {
      display: none;
    }
  }

  // --- Tree layout ---
  .org-tree {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .org-row {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    width: 100%;
  }

  .org-connector {
    width: 1px;
    height: 24px;
    background: $org-black;
  }

  // Real org-chart branching: a single trunk line down, then a thin
  // bracket line connecting each child to its siblings and dropping
  // a thin line into each one.
  .org-row.org-tree-branch,
  .org-branches.org-tree-branch {
    gap: 0;
    padding-top: 24px;

    > * {
      position: relative;
      margin: 0 14px;
    }

    > *::before {
      content: "";
      position: absolute;
      top: -24px;
      left: 50%;
      width: 1px;
      height: 24px;
      background: $org-black;
    }

    > *::after {
      content: "";
      position: absolute;
      top: -24px;
      left: -14px;
      right: -14px;
      height: 1px;
      background: $org-black;
    }

    > *:first-child::after {
      left: 50%;
    }

    > *:last-child::after {
      right: 50%;
    }

    > *:only-child::after {
      display: none;
    }
  }

  // Below this width the row can no longer fit every child on one
  // line: wrapping would break the bracket line's geometry and send
  // it across unrelated cards, so scroll horizontally instead and
  // keep the tree intact.
  @media (max-width: 1100px) {
    .org-row.org-tree-branch,
    .org-branches.org-tree-branch {
      flex-wrap: nowrap;
      justify-content: flex-start;
      overflow-x: auto;
      padding-bottom: 12px;
      -webkit-overflow-scrolling: touch;

      > * {
        flex-shrink: 0;
      }
    }
  }

  .org-box {
    border-radius: 8px;
    overflow: hidden;
    min-width: 160px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .org-box-main {
    background: $org-orange;
    color: #fff;
    font-weight: 800;
    text-align: center;
    padding: 14px 20px;
    letter-spacing: 1px;
  }

  .org-box-sub {
    border: 1px solid $org-orange;

    .org-box-header {
      background: $org-orange;
      color: #fff;
      font-weight: 700;
      text-align: center;
      padding: 8px 16px;
    }

    .org-box-body {
      padding: 8px 16px;
      text-align: center;

      p {
        margin: 0;
        font-size: 0.85rem;
      }
    }
  }

  .org-branches {
    display: flex;
    justify-content: center;
    gap: 24px;
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .org-branch {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    min-width: 260px;
    max-width: 360px;
    gap: 12px;
  }

  .org-box-branch {
    background: $org-orange;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding: 10px 16px;
    width: 100%;
  }

  .org-branch-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .org-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .org-box-group {
    border: 1px solid #e0c2ad;
    background: #fdf3ee;
    width: 100%;

    .org-box-header {
      font-weight: 700;
      text-align: center;
      padding: 6px 12px;
      font-size: 0.85rem;

      .org-tag {
        display: block;
        font-weight: 400;
        font-size: 0.7rem;
        color: $org-orange;
      }
    }

    .org-box-body {
      padding: 4px 12px 8px;
      text-align: center;

      p {
        margin: 0;
        font-size: 0.78rem;
      }
    }
  }

  .org-subgroups {
    display: flex;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
  }

  .org-box-sub-small {
    border: 1px solid #ddd;
    background: #fff;
    flex: 1;
    min-width: 100px;

    .org-box-header {
      font-weight: 700;
      text-align: center;
      padding: 4px 8px;
      font-size: 0.72rem;
      background: #f0f0f0;
    }

    .org-box-body {
      padding: 4px 8px;
      text-align: center;

      p {
        margin: 0;
        font-size: 0.7rem;
      }
    }
  }

  .org-flag {
    display: inline-block;
    width: 26px;
    height: 18px;
    border-radius: 2px;
    vertical-align: middle;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
    position: relative;
    overflow: hidden;
  }

  .org-flag-fr {
    background: linear-gradient(
      to right,
      #0055a4 0%,
      #0055a4 33%,
      #ffffff 33%,
      #ffffff 66%,
      #ef4135 66%,
      #ef4135 100%
    );
  }

  .org-flag-es {
    background: linear-gradient(
      to bottom,
      #aa151b 0%,
      #aa151b 25%,
      #f1bf00 25%,
      #f1bf00 75%,
      #aa151b 75%,
      #aa151b 100%
    );
  }

  .org-flag-br {
    background: #009739;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      margin: auto;
      width: 70%;
      height: 70%;
      background: #fedd00;
      clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 38%;
      height: 38%;
      background: #002776;
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .org-tag {
    font-size: 0.65rem;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 4px;
    padding: 1px 6px;
    margin-left: 4px;
  }

  // --- Commissions grid ---
  .org-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    max-width: 1100px;
    margin: 0 auto;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .org-card {
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    padding: 16px 18px;
  }

  .org-card-title {
    font-weight: 800;
    color: $org-orange;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  .org-card-list {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      font-size: 0.85rem;
      padding: 2px 0;
      color: $org-black;
    }
  }

  .org-card-empty {
    font-size: 0.85rem;
    color: #999;
    font-style: italic;
  }

  // --- Bureau tree specific rows ---
  .org-row-double .org-box {
    background: $org-black;
    color: #fff;

    .org-box-header {
      text-align: center;
      font-weight: 700;
      padding: 8px 20px;
      color: $org-orange;
    }

    .org-box-body {
      text-align: center;
      padding: 4px 20px 10px;

      p {
        margin: 0;
        font-weight: 700;
      }
    }
  }

  .org-box-black {
    border-radius: 8px;
    min-width: 200px;
  }

  .org-row-four,
  .org-row-five {
    gap: 16px;
    max-width: 1100px;
  }

  .org-box-office {
    border: 1px solid #e0c2ad;
    background: #fdf3ee;
    flex: 1;
    min-width: 150px;
    max-width: 220px;
    overflow: visible;

    .org-box-header {
      font-weight: 700;
      text-align: center;
      padding: 6px 12px;
      font-size: 0.85rem;
    }

    .org-box-body {
      padding: 4px 12px 8px;
      text-align: center;

      p {
        margin: 0;
        font-size: 0.78rem;
      }
    }
  }

  .org-banner {
    background: $org-black;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding: 8px 24px;
    border-radius: 6px;
    margin-top: 16px;
  }

  .org-branch-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-width: 140px;
    max-width: 200px;
  }
}
</style>
